<span class = "material-icons">
    {{ icon }}
</span>